"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionName = void 0;
var InteractionName;
(function (InteractionName) {
    InteractionName["ALE"] = "load";
    InteractionName["ALE_KICKOFF"] = "load-phase-kickoff";
    InteractionName["ALE_RENDER"] = "load-phase-render";
    InteractionName["SQUARE_SDK_INIT"] = "square-sdk-init";
    InteractionName["SQUARE_SDK_TOKENIZE"] = "square-sdk-tokenize";
    InteractionName["RESOLVE_WEBSITE_URL"] = "resolve-website-url";
    InteractionName["TWO_CHECKOUT_SDK_TOKENIZE"] = "two-checkout-sdk-tokenize";
    InteractionName["API_TOKENIZE"] = "api-tokenize";
    InteractionName["API_SAVE"] = "api-save";
    InteractionName["API_UPDATE"] = "api-update";
    InteractionName["API_VALIDATE"] = "api-validate";
    InteractionName["API_GET_PUBLIC_DATA"] = "api-get-public-data";
})(InteractionName = exports.InteractionName || (exports.InteractionName = {}));
//# sourceMappingURL=InteractionName.js.map